import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function HeroSection() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      headline: 'Your Story Deserves To Be Eternal',
      subhead: 'Fine Art Realism Tattoo | Miami, FL',
      btn1: 'Book on WhatsApp',
      btn2: 'DM on Instagram'
    },
    es: {
      headline: 'Tu Historia Merece Ser Eterna',
      subhead: 'Tatuaje de Realismo Fine Art | Miami, FL',
      btn1: 'Reserva por WhatsApp',
      btn2: 'Escríbeme en Instagram'
    }
  };
  const t = content[language];
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-54">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/6NXjSifnE3dqRGjg8rArCj/HERO_PAGE.png')] bg-cover bg-center" data-id="element-55" />
      <div className="absolute inset-0 bg-brand-black/60" data-id="element-56" />
      <div className="absolute inset-0 bg-gold-gradient" data-id="element-57" />

      <div className="relative z-10 flex flex-col items-center text-center px-4 max-w-5xl mx-auto" data-id="element-58">
        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-brand-gold leading-tight mb-6" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-59">
          {t.headline}
        </motion.h1>

        <motion.div className="w-24 h-px bg-brand-gold mb-8 opacity-70" initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.3
      }} data-id="element-60" />

        <motion.p className="text-lg md:text-xl text-brand-white font-sans font-light tracking-widest uppercase mb-12" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-61">
          {t.subhead}
        </motion.p>

        <motion.div className="flex flex-col sm:flex-row gap-6 w-full max-w-xl justify-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.7
      }} data-id="element-62">
          <a href="https://wa.me/13057256699" target="_blank" rel="noopener noreferrer" className="flex-1 py-4 px-8 border border-brand-gold text-brand-gold font-serif text-lg tracking-widest uppercase text-center transition-all duration-300 hover:bg-brand-gold hover:text-brand-black" data-id="element-63">
            {t.btn1}
          </a>
          <a href="https://ig.me/m/krlygoldtattoo" target="_blank" rel="noopener noreferrer" className="flex-1 py-4 px-8 border border-brand-gold text-brand-gold font-serif text-lg tracking-widest uppercase text-center transition-all duration-300 hover:bg-brand-gold hover:text-brand-black" data-id="element-64">
            {t.btn2}
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-brand-gold/30" data-id="element-65" />
    </section>;
}